
export interface SafetyPageTitleProps {
    title: string
    className?: string
}

export default function SafetyPageTitle(props: SafetyPageTitleProps) {

    return <div className={"safety-page-title " + (props.className || "")}>
        <img src="images/safety/title.png" alt=""/>
        <h1>{props.title}</h1>
    </div>
}
